module.exports = __webpack_public_path__ + "static/media/closed-hi-hat.9bb9eb8e.wav";